import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import { Integrations } from '@sentry/tracing';
import App from './App';

Sentry.init(
  {
    dsn: 'https://269ce6c16acd4e19ba491fc27f896154@o28326.ingest.sentry.io/5699909',
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.1,
  },
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
